import React from "react";
import {ArrowDownCircle, ArrowDownUp, ArrowUpCircle} from "react-bootstrap-icons";
import LabelWithTooltip from "./LabelWithTooltip";
import {LEGENDS} from "./CanopiaUtils";

export default function HSort(props) {

    const label = props.label;
    const colName = props.colName;
    const state = props.state;
    const sortFunc = props.sortFunc;

    const sortStatus = state.sortStatus;
    const sortCol = state.sortCol;

    const showLegend = props.showLegend;

    let sortIcon;

    if (sortCol === colName) {
        if (sortStatus[colName] === 'asc') {
            sortIcon = <ArrowUpCircle className={"react-icons canopia"} size={'1.4em'} style={{paddingBottom: "2px"}}/>;
        } else {
            sortIcon = <ArrowDownCircle className={"react-icons canopia"} size={'1.4em'} style={{paddingBottom: "2px"}}/>;
        }
    } else {
        sortIcon = <ArrowDownUp className={"react-icons canopia2"} size={'1.1em'} style={{paddingBottom: "2px"}}/>;
    }

    return (
        <span style={{display: "inline"}}>
            {showLegend ? <LabelWithTooltip label={label} text={LEGENDS[colName]}/> : label}
            <span style={{display: "inline", marginLeft: "5px"}} className={'label-hover nowrap'} onClick={() => sortFunc(colName)}>
                {sortIcon}
            </span>
        </span>
    );
}
